import { InvitationsListView } from './InvitationsList.view';
import { useEffect, useMemo, useState } from 'react';
import { useInvitationsUserManagementSlice } from '@restore/invitationsUserManagement/invitationsUserManagement.slice';
import { useFacilitiesSlice } from '@restore/facilities/facilities.slice';

export const InvitationsListPage = () => {
  const [
    fetchInvitationsList,
    fetchInvitationSponsors,
    data,
    loading,
    sponsors,
  ] = useInvitationsUserManagementSlice((state, actions) => [
    actions.fetchInvitationsList,
    actions.fetchInvitationSponsors,
    state.data,
    state.loading,
    state.sponsors,
  ]);

  const [facilities, fetchFacilities] = useFacilitiesSlice(
    (state, actions) => [state.data, actions.fetchFacilities]
  );

  const [explicitSelection, setExplicitSelection] = useState<string>();
  const effectiveSponsorId = explicitSelection ?? sponsors[0]?.id;

  useEffect(() => {
    fetchInvitationSponsors(undefined);
    fetchFacilities(undefined);
  }, [fetchInvitationSponsors, fetchFacilities]);

  useEffect(() => {
    if (effectiveSponsorId) {
      fetchInvitationsList({ sponsorId: effectiveSponsorId });
    }
  }, [effectiveSponsorId, fetchInvitationsList]);

  const refetchInvitations = () => {
    if (effectiveSponsorId) {
      fetchInvitationsList({ sponsorId: effectiveSponsorId });
    }
  };

  const sponsorOptions = sponsors.map(s => ({
    label: s.name,
    value: s.id,
  }));

  const facilityMap = useMemo(
    () => Object.fromEntries(facilities.map(f => [f.id, f.name])),
    [facilities]
  );

  return (
    <div data-testid='InvitationsList' className='h-full'>
      <InvitationsListView
        loading={loading}
        invitationsData={data}
        facilityMap={facilityMap}
        sponsorOptions={sponsorOptions}
        selectedSponsorId={effectiveSponsorId}
        onSponsorChange={setExplicitSelection}
        refetchInvitations={refetchInvitations}
      />
    </div>
  );
};
